import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux';
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { renderFieldCnpj, renderFieldSelect, renderFieldText, required, requiredSelect,
    validarApenasNumero,
    validarCNPJ,    
    renderFieldCheck,
    renderFieldCep
 } from '../../util/inputs';
import { renderField } from '../../util/arraysUtil';
import transmitirCte from '../../actions/encomenda/transmitirCte';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import { showSuccessMsg } from '../../util/messagesUtil';
import {tipoIndicadorContribuicaoIE} from '../../util/constantsUtil';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import $ from 'jquery';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { obterNaturezaOperacaoPadrao } from '../../util/cteUtil';

export class ModalTransmitirCte extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.limparCampos = this.limparCampos.bind(this);

        this.state = {
            naturezaOperacao: null,
            tipoServico: null,
            tipoIndicadorContribuicaoIE: {}

        }
    }

    componentDidMount() {
        this.aplicarNaturezaOperacaoPadrao();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.naturezasOperacoes !== this.props.naturezasOperacoes) {
            this.aplicarNaturezaOperacaoPadrao();
        }
    }

    aplicarNaturezaOperacaoPadrao() {
        if (!this.state.naturezaOperacao) {
            const padrao = obterNaturezaOperacaoPadrao(this.props.naturezasOperacoes);
            if (padrao) {
                this.props.changeFieldValue('formularioTransmitirCte', 'naturezaOperacao', padrao);
                this.setState({ naturezaOperacao: padrao });
            }
        }
    }

    fecharModal() {
        $('#modalTransmitirCte').modal('hide');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        this.limparFormulario();
    }

    limparFormulario() {
        this.setState({
            naturezaOperacao: null,
            tipoServico: null
        }, () => this.aplicarNaturezaOperacaoPadrao())
        this.selecionarOrigem(null)
        this.props.reset('formularioTransmitirCte');
    }

    handleSelecionarTipoServico(e) {
        this.setState({
            tipoServico: e
        })
        if (e && e.value === 'NORMAL' && this.props.habilitadoChaveCteAnterior) {
            this.props.changeFieldValue('formularioTransmitirCte', 'habilitadoChaveCteAnterior', false);
        }
    }

    tipoServicoNormalSelecionado() {
        const tipoServicoCte = this.props.tipoServicoCte;
        return !!(tipoServicoCte && tipoServicoCte.value === 'NORMAL');
    }

    handleSelecionarNatureza(e) {
        this.setState({
            naturezaOperacao: e
        })
    }

    handleSelecionarindicadorContribuicao(evento) {
            this.setState({ tipoIndicadorContribuicaoIE: evento });
    }

    limpaViagens () {
        this.props.selecionarOrigem(null)
    }

    limparCampos() {
        this.props.changeFieldValue('formularioTransmitirCte',
            'logradouro', '');
        this.props.changeFieldValue('formularioTransmitirCte',
            'complemento', '');
        this.props.changeFieldValue('formularioTransmitirCte',
            'bairro', '');
        this.props.changeFieldValue('formularioTransmitirCte',
            'uf', '');
    }

    selecionarOrigem(origem) {
        this.props.selecionarOrigem(origem)
    }

    montarParametros(values) {
        return {
            encomendaId: this.props.encomenda.id,
            empresaId: this.props.empresaSelecionada.id,
            naturezaOperacao: this.state.naturezaOperacao && this.state.naturezaOperacao.value ? this.state.naturezaOperacao.value : this.props.encomenda.naturezaOperacao,
            tipoServicoCte: this.state.tipoServico && this.state.tipoServico.value ? this.state.tipoServico.value : this.props.encomenda.tipoServicoCte.chave,
            rntrc: this.props.rntrc ? this.props.rntrc : this.props.encomenda.rntrc,
            chaveNfe: this.props.chaveNfe ? this.props.chaveNfe : this.props.encomenda.chaveNfe,
            habilitadoChaveCteAnterior: this.props.habilitadoChaveCteAnterior,
            emitenteCteAnterior: this.props.habilitadoChaveCteAnterior ? {                
                cpjCnpj: values.numeroCnpj ? values.numeroCnpj : null,
                nome: values.nomeFantasia,
                razaoSocial: values.razaoSocial,
                inscricaoEstadual: this.props.inscricaoEstadual,
                uf: this.props.uf,
                chaveCte: this.props.chaveCte,
                tipoIndicadorContribuicao: this.props.tipoIndicadorContribuicaoIE.value,
                enderecoDto: {
                    cep: values.cep,
                    logradouro: values.logradouro,
                    complemento: values.complemento,
                    bairro: values.bairro,
                    codigoCidade: this.props.origem.id,
                    uf: this.props.origem.uf,
                    numero: values.numero,
                    localidade: this.props.origem.nome,
                    nomeCidade: this.props.origem.nome
                }
            }: null
        }
    }

    submit(values) {        
        this.props.transmitirCte(this.montarParametros(values))
            .then(() => {
                showSuccessMsg('Foi iniciado a transmissão do ct-e!');
                this.props.buscarPedidos();
                this.fecharModal();
            })
    }

    preencherCamposEmitenteCteAnterior() {
        return <>
            <div className="form-row">
                <div className="col-12 col-sm-6 col-md-6">
                    <Field name="chaveCte" type="text" validate={[required]} component={renderField}
                        label="Chave Cte:"
                        css="form-control"
                    />
                </div>
            </div>
            {this.exibirCamposEmpresa()}
            {this.exibirCamposEndereco()}
        </>
    }

    exibirCamposEmpresa() {
        return (
            <div>
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="nomeFantasia"
                                css='form-control'
                                validate={[required]}
                                component={renderFieldText}
                                label="Nome Fantasia"/>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="razaoSocial"
                                css='form-control'
                                validate={[required]}
                                component={renderFieldText}
                                label="Razão Social"/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="numeroCnpj"
                                css='form-control'
                                validate={[required, validarCNPJ]}
                                component={renderFieldCnpj}
                                label="Número CNPJ"/>
                    </div>                
                    <div className="col-12 col-sm-3 col-md-3">
                        {this.state.tipoIndicadorContribuicaoIE.value == 'CONTRIBUINTE_ICMS' ? <Field name="inscricaoEstadual"
                                css='form-control'
                                component={renderFieldText}
                                label="Inscrição Estadual"
                                validate={[required]}
                        />:
                        <Field name="inscricaoEstadual"
                                css='form-control'
                                component={renderFieldText}
                                label="Inscrição Estadual"
                        /> }
                    </div>                    
                </div>
            </div>
        )
    }

    pesquisarPorCep(event) {
        const CEP = event.target.value.replace(/\D/g, '')
        if (CEP.length === 8) {
            const url = `${URL}/cep/public/${CEP}`
            axios.get(url, SLOW_REQUEST_CONFIG).then((resp) => {
                if (resp.status === 200) {
                    this.props.changeFieldValue('formularioTransmitirCte',
                        'logradouro', resp.data.logradouro);
                    this.props.changeFieldValue('formularioTransmitirCte',
                        'complemento', resp.data.complemento);
                    this.props.changeFieldValue('formularioTransmitirCte',
                        'bairro', resp.data.bairro);
                    this.props.changeFieldValue('formularioTransmitirCte',
                        'uf', resp.data.uf);
                }
            })
        }
        this.limparCampos()
    }

    exibirCamposEndereco() {
        return (
            <div>
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="cep" type="text" validate={[required]} component={renderFieldCep} label="CEP:"
                                css="form-control" readOnly={false} onChange={e => this.pesquisarPorCep(e)}/>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name='tipoIndicadorContribuicaoIE'
                                options={tipoIndicadorContribuicaoIE.map(elemento => ({
                                    descricao: elemento.label,
                                    nome: elemento.value
                                }))}
                                placeholder='Selecione...'
                                onChange={(e) => this.handleSelecionarindicadorContribuicao(e)}
                                component={renderFieldSelect}
                                label='Indicador Contribuição:' validate={requiredSelect}/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-9 col-md-9">
                        <Field name="logradouro" type="text" validate={[required]} component={renderField}
                                label="Logradouro:"
                                css="form-control" readOnly={false}/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="bairro" type="text" validate={[required]} component={renderField} label="Bairro:"
                                css="form-control" readOnly={false}/>
                    </div>
                    <div className="col-12 col-sm-5 col-md-5">
                        <Field name="complemento" type="text" validate={[required]} component={renderField} label="Complemento:"
                            css="form-control" readOnly={false} />
                    </div>
                    <div className="col-12 col-sm-9 col-md-3">
                        <Field name="numero" type="text" validate={[required, validarApenasNumero]} component={renderField} label="Número:"
                            css="form-control" readOnly={false} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 mt-2">
                        <label>Cidade:</label>
                    </div>
                    <SelecaoCidadeAutocomplete name='informeCidade'
                        selecionarCidade={this.props.selecionarOrigem}
                        value={this.props.origem}
                        limparViagens={this.limpaViagens.bind(this)}
                        ehVenda={true}
                    />
                </div>
                <div className="form-group area-codigo">
                    <Field name="idEndereco" type="hidden" component={renderField} css="form-control col-md-12" />
                    <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12"/>
                </div>
            </div>
        )
    }

    formulario() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        return (
            <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='tipoServicoCte'
                            options={this.props.tiposServicos.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            onChange={(e) => this.handleSelecionarTipoServico(e)}
                            component={renderFieldSelect}
                            label='Tipo Serviço:'
                            placeholder='Selecione...' validate={requiredSelect}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="rntrc" type="text" validate={[required]} component={renderField}
                            label="RNTRC:"
                            css="form-control"
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-12 col-md-12">
                        <Field name='naturezaOperacao'
                            options={this.props.naturezasOperacoes.map(it => ({
                                descricao: it.valor,
                                nome: it.chave
                            }))}
                            component={renderFieldSelect}
                            label="Natureza da Operação:"
                            placeholder='Selecione...' validate={requiredSelect}
                            onChange={(e) => this.handleSelecionarNatureza(e)}
                        />
                    </div>
                </div>
                {!this.tipoServicoNormalSelecionado() && (
                    <div className="form-row mt-4">
                        <div className="col-12 col-sm-6 col-md-6">
                            <Field name='habilitadoChaveCteAnterior' type="checkbox" component={renderFieldCheck}
                                label="Habilitar Emitente Cte Anterior"
                                css="form-check-input" readOnly={false} />
                        </div>
                    </div>
                )}
                {this.props.habilitadoChaveCteAnterior && !this.tipoServicoNormalSelecionado() ?<>
                    {this.preencherCamposEmitenteCteAnterior()}
                </>: ''}
                {!(this.props.habilitadoChaveCteAnterior && !this.tipoServicoNormalSelecionado()) ? <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="chaveNfe" type="text" validate={[required]} component={renderField}
                            label="Chave NF-e:"
                            css="form-control"
                        />
                    </div>
                </div>: ''}
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                        onClick={() => this.fecharModal()}>Cancelar
                    </button>
                    <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-modal-btn-confirmar">
                        <span className="material-icons" style={{ fontSize: 15 }}>send</span>
                        Transmitir
                    </button>
                </div>
            </form>
        )
    }

    render() {
        return (
            <div className="modal fade show" id="modalTransmitirCte" role="dialog"
                aria-labelledby="modalTransmitirCte" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                        <div className="vx-modal-header">
                            <div className="vx-modal-title">
                                <span className="material-icons">send</span>
                                Transmissão CT-e
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fecharModal()}>
                                <span className="material-icons">close</span>
                            </button>
                        </div>
                        <div className="vx-modal-body" style={{ background: '#fff' }}>
                            {this.formulario()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        encomenda: state.encomenda,
        empresaSelecionada: state.empresaSelecionada,
        tiposServicos: state.opcoesFiltrosEmissaoesCte.tipoServicoCte,
        naturezasOperacoes: state.opcoesFiltrosEmissaoesCte.naturezasOperacoes,
        usuarioVendeEncomendaComCte: state.usuarioVendeEncomendaComCte,
        rntrc: formValueSelector('formularioTransmitirCte')(state, 'rntrc'),
        chaveNfe: formValueSelector('formularioTransmitirCte')(state, 'chaveNfe'),
        cnpj: formValueSelector('formularioTransmitirCte')(state, 'cnpj'),        
        origem: state.origem,        
        numeroCnpj: formValueSelector('formularioTransmitirCte')(state, 'numeroCnpj'),        
        nomeFantasia: formValueSelector('formularioTransmitirCte')(state, 'nomeFantasia'),
        razaoSocial: formValueSelector('formularioTransmitirCte')(state, 'razaoSocial'),
        inscricaoEstadual: formValueSelector('formularioTransmitirCte')(state, 'inscricaoEstadual'),        
        cep: formValueSelector('formularioTransmitirCte')(state, 'cep'),
        tipoIndicadorContribuicaoIE: formValueSelector('formularioTransmitirCte')(state, 'tipoIndicadorContribuicaoIE'),
        habilitadoChaveCteAnterior: formValueSelector('formularioTransmitirCte')(state, 'habilitadoChaveCteAnterior'),
        chaveCte: formValueSelector('formularioTransmitirCte')(state, 'chaveCte'),
        tipoServicoCte: formValueSelector('formularioTransmitirCte')(state, 'tipoServicoCte'),
    }
}

export default connect(mapStateToProps, {
    changeFieldValue,
    selecionarOrigem,
    transmitirCte
})(reduxForm({
    form: 'formularioTransmitirCte'
})(ModalTransmitirCte));